// Mobile Xpressed — translation dictionary (EN / ID)
// Keep keys flat and namespaced by page for easy maintenance.
export const translations = {
  en: {
    // Navbar
    "nav.repairServices": "Repair Services",
    "nav.batteries": "Batteries",
    "nav.parts": "Parts",
    "nav.accessories": "Accessories",
    "nav.signIn": "Sign in",
    "nav.getStarted": "Get started",
    "nav.openCart": "Open cart",
    "nav.searchProducts": "Search products",
    "nav.myAccount": "My Account",
    "nav.admin": "Admin",
    "nav.logOut": "Log out",

    // Preview / feedback banner
    "banner.welcome": "This page is under construction and currently in preview mode, but will be fully functional by September 15, 2026 at the latest.",
    "banner.hint": "For comments, critique and advice, please type in the textbox below.",
    "banner.placeholder": "Your feedback, questions or suggestions…",
    "banner.send": "Send my feedback",
    "banner.sending": "Sending…",
    "banner.thankYouTitle": "Thank you",
    "banner.thankYouBody": "We will listen to your feedback gracefully and carefully.",
    "banner.thankYouClose": "Close",
    "banner.errorEmpty": "Please type your feedback first.",
    "banner.errorGeneric": "Couldn't send right now. Please try again.",
    "banner.errorRate": "Too many messages from you. Please wait a while.",

    // Home
    "home.badge": "Trusted TWS repair since 2022",
    "home.heroTitle1": "Revive your earbuds",
    "home.heroTitle2": "back to life.",
    "home.heroSubtitle": "Precision-grade TWS batteries, replacement parts, and expert repair services. Restore performance fast.",
    "home.catRepairTitle": "Repair Services",
    "home.catBatteriesTitle": "Batteries",
    "home.catPartsTitle": "Parts",
    "home.catAccessoriesTitle": "Accessories",
    "home.catPartsShortDesc": "Earbuds & Charging cases.",
    "home.catAccessoriesShortDesc": "Eartips, protective cases — small upgrades, big impact.",
    "home.shopBatteries": "Shop batteries",
    "home.repairServices": "Repair services",
    "home.warranty": "30-day warranty",
    "home.turnaround": "~5-day turnaround",
    "home.certified": "Certified techs",
    "home.thisWeek": "This week",
    "home.repairs": "120+ repairs",
    "home.happyCustomers": "Happy customers",
    "home.catRepairDesc": "Certified repair with a quote after inspection.",
    "home.catBatteriesDesc": "OEM-grade replacement cells for every major brand.",
    "home.catPartsDesc": "Drivers, cases, hinges, and precision toolkits.",
    "home.catAccessoriesDesc": "Cables, tips, cases — small upgrades, big impact.",
    "home.explore": "Explore",
    "home.featured": "Featured",
    "home.featuredTitle": "Restore performance today",
    "home.viewAll": "View all",
    "home.loading": "Loading products…",
    "home.guaranteed": "Guaranteed",
    "home.trustTitle": "Every part, every repair — backed by our 30-day warranty.",
    "home.trustCopy": "We stand behind every battery and repair. If something isn't right, we'll make it right.",
    "home.learnMore": "Learn about repairs",

    // FAQ
    "faq.badge": "FAQ",
    "faq.title": "Frequently asked questions",
    "faq.subtitle": "Everything you need to know before booking a repair or placing an order.",
    "faq.q1": "What types of TWS earbuds do you repair?",
    "faq.a1": "We repair all major brands including Sony, Samsung, Apple, Jabra, Bose, and many more.",
    "faq.q2": "How long does a repair take?",
    "faq.a2": "Repairs typically take 5 days from the time we receive your device.",
    "faq.q3": "How much does a repair cost?",
    "faq.a3": "Repair costs are quoted after inspection. We will contact you for confirmation before proceeding.",
    "faq.q4": "What if my earbuds cannot be repaired?",
    "faq.a4": "We will notify you with a full condition report and return your device safely.",
    "faq.q5": "Which couriers do you use?",
    "faq.a5": "We ship via J&T, Pos Indonesia, and Paxel.",
    "faq.q6": "How do I track my order?",
    "faq.a6": "You will receive a WhatsApp notification with your courier name and tracking number once your device is shipped.",
    "faq.q7": "Do you offer a warranty on repairs?",
    "faq.a7": "Yes, we provide a warranty on all repair services conducted by Mobile Xpressed.",
    "faq.q8": "How do I contact Mobile Xpressed?",
    "faq.a8": "You can reach us via WhatsApp using the Contact Us button on our homepage.",

    // Testimonials
    "testimonials.badge": "Loved by",
    "testimonials.title": "The people who care about sound.",
    "testimonials.subtitle": "From producers to weekend runners — thousands trust Mobile Xpressed to bring their gear back to life.",
    "testimonials.t1.quote": "My AirPods Pro sounded brand new after their battery swap. Turnaround was under 24 hours. Absolutely worth it.",
    "testimonials.t1.role": "Producer, NYC",
    "testimonials.t2.quote": "I ordered the toolkit and did the repair myself. The instructions were perfect and my Galaxy Buds are alive again.",
    "testimonials.t2.role": "Software Engineer",
    "testimonials.t3.quote": "Great pricing on TWS batteries and shipped fast. I've told everyone at my studio about Mobile Xpressed.",
    "testimonials.t3.role": "Sound Designer",

    // Order status
    "status.pending": "Pending",
    "status.paid": "Paid",
    "status.shipped": "Shipped",
    "status.delivered": "Delivered",
    "status.cancelled": "Cancelled",
    "status.refunded": "Refunded",

    // Shop
    "shop.badge": "Shop",
    "shop.title": "Everything you need",
    "shop.subtitle": "Batteries, parts and accessories carefully selected to restore your TWS earbuds to peak performance.",
    "shop.searchPlaceholder": "Search batteries, parts, brands…",
    "shop.clearSearch": "Clear search",
    "shop.filterAll": "All",
    "shop.filterRepair": "Repair Services",
    "shop.filterBatteries": "Batteries",
    "shop.filterParts": "Parts",
    "shop.filterAccessories": "Accessories",
    "shop.loading": "Loading products…",
    "shop.noResults": "No products found",
    "shop.noMatch": "No matches for",
    "shop.tryDifferent": "Try a different category.",
    "shop.resultsFor": "result(s) for",

    // Product card
    "product.add": "Add",

    // Product detail
    "product.back": "Back",
    "product.addToCart": "Add to cart",
    "product.reviews": "review(s)",
    "product.freeShipping": "Free shipping",
    "product.thirtyDayReturns": "30-day returns",
    "product.warranty": "30-day warranty",
    "product.brand": "Brand",
    "product.stock": "Stock",
    "product.notFound": "Product not found",
    "product.backToShop": "Back to shop",
    "product.loading": "Loading…",

    // Product reviews
    "reviews.customerReviews": "Customer reviews",
    "reviews.noReviews": "No reviews yet. Be the first to share your experience.",
    "reviews.signInPrompt": "Sign in to leave a review.",
    "reviews.signIn": "Sign in",
    "reviews.writeReview": "Write a review",
    "reviews.yourRating": "Your rating",
    "reviews.title": "Title",
    "reviews.titlePlaceholder": "Sums up your experience",
    "reviews.yourReview": "Your review",
    "reviews.reviewPlaceholder": "What worked, what didn't, tips for future buyers…",
    "reviews.postReview": "Post review",
    "reviews.posting": "Posting…",
    "reviews.pickRating": "Please pick a rating",
    "reviews.alreadyReviewed": "Thanks — you've already reviewed this product.",
    "reviews.verified": "Verified",
    "reviews.deleteConfirm": "Delete your review?",
    "reviews.deleted": "Review deleted",
    "reviews.posted": "Review posted",
    "reviews.loading": "Loading reviews…",

    // Cart
    "cart.title": "Your Cart",
    "cart.empty": "Your cart is empty",
    "cart.emptyHint": "Add batteries or parts to get started.",
    "cart.browseShop": "Browse shop",
    "cart.subtotal": "Subtotal",
    "cart.shippingNotice": "Shipping & taxes calculated at checkout.",
    "cart.checkout": "Checkout",

    // Checkout
    "checkout.title": "Checkout",
    "checkout.shippingDetails": "Shipping details",
    "checkout.fullName": "Full name",
    "checkout.province": "Province",
    "checkout.provincePlaceholder": "Select province",
    "checkout.regency": "City / Regency",
    "checkout.regencyPlaceholder": "Select city/regency",
    "checkout.district": "District (Kecamatan)",
    "checkout.districtPlaceholder": "Select district",
    "checkout.village": "Village (Kelurahan/Desa)",
    "checkout.villagePlaceholder": "Select village",
    "checkout.postalCode": "Postal code",
    "checkout.postalCodePlaceholder": "Auto-filled",
    "checkout.addressLoadError": "Couldn't load options. Check your connection and try again.",
    "checkout.retry": "Retry",
    "checkout.addressDetail": "Detailed address",
    "checkout.addressDetailPlaceholder": "Street name, house number, RT/RW, building, floor…",
    "checkout.phone": "Phone",
    "checkout.stripeNotice": "You'll be redirected to Stripe's secure checkout to complete payment. Test card: 4242 4242 4242 4242, any future date, any CVC.",
    "checkout.paySecurely": "Pay securely",
    "checkout.redirecting": "Redirecting to Stripe…",
    "checkout.orderSummary": "Order summary",
    "checkout.qty": "Qty",
    "checkout.shipping": "Shipping",
    "checkout.free": "Free",
    "checkout.total": "Total",
    "checkout.pleaseSignIn": "Please sign in to checkout.",
    "checkout.cartEmpty": "Your cart is empty.",
    "checkout.continueShopping": "Continue shopping",
    "checkout.addressIncomplete": "Please complete province, city, district and village to auto-fill your postal code.",
    "checkout.savedAddresses": "Saved addresses",
    "checkout.useNewAddress": "Use a new address",
    "checkout.saveThisAddress": "Save this address for my next order",
    "checkout.addressLabel": "Label (e.g. Home, Office)",

    // Payment
    "payment.confirming": "Confirming payment…",
    "payment.confirmingSub": "Hang tight while we verify your transaction with Stripe.",
    "payment.success": "Payment successful",
    "payment.successMsg": "Thanks for shopping with Mobile Xpressed. We'll email you an update as your order ships.",
    "payment.viewOrders": "View my orders",
    "payment.keepShopping": "Keep shopping",
    "payment.stillProcessing": "Still processing…",
    "payment.stillProcessingSub": "Your payment is taking longer than expected. Check your account for the final status.",
    "payment.goToAccount": "Go to account",
    "payment.failed": "Payment failed",
    "payment.failedSub": "We couldn't confirm your payment. Please try again.",
    "payment.backToCheckout": "Back to checkout",
    "payment.cancelled": "Payment cancelled",
    "payment.cancelledSub": "No worries — your cart is still saved. You can complete checkout whenever you're ready.",
    "payment.returnToCheckout": "Return to checkout",

    // Auth
    "auth.welcomeBack": "Welcome back",
    "auth.welcomeSub": "Sign in to continue your Mobile Xpressed journey.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signIn": "Sign in",
    "auth.signingIn": "Signing in…",
    "auth.continueGoogle": "Continue with Google",
    "auth.orEmail": "or email",
    "auth.newHere": "New to Mobile Xpressed?",
    "auth.createAccount": "Create an account",
    "auth.createTitle": "Create account",
    "auth.createSub": "Join Mobile Xpressed to track orders and save favourites.",
    "auth.name": "Name",
    "auth.createBtn": "Create account",
    "auth.creating": "Creating…",
    "auth.haveAccount": "Already have an account?",
    "auth.welcomeToast": "Welcome back!",
    "auth.createdToast": "Account created — welcome!",

    // Account
    "account.yourOrders": "Your orders",
    "account.orders": "Orders",
    "account.adminPanel": "Admin panel",
    "account.logOut": "Log out",
    "account.noOrders": "No orders yet",
    "account.noOrdersHint": "Your future orders will appear here.",
    "account.startShopping": "Start shopping",
    "account.order": "Order",
    "account.qty": "Qty",
    "account.loading": "Loading…",
    "account.addresses": "Addresses",
    "account.savedAddresses": "Saved addresses",
    "account.noAddresses": "No saved addresses yet",
    "account.noAddressesHint": "Save an address at checkout or add one here to speed up your next order.",
    "account.addAddress": "Add address",
    "account.editAddress": "Edit address",
    "account.deleteAddress": "Delete",
    "account.setDefault": "Set as default",
    "account.default": "Default",
    "account.addressLabel": "Label",
    "account.addressLabelPlaceholder": "Home, Office…",
    "account.recipientName": "Recipient name",
    "account.saveAddress": "Save address",
    "account.saving": "Saving…",
    "account.addressSaved": "Address saved.",
    "account.addressDeleted": "Address deleted.",
    "account.defaultUpdated": "Default address updated.",
    "account.cancel": "Cancel",
    "account.deleteConfirm": "This address will be permanently removed.",

    // Repair services
    "services.badge": "Repair Services",
    "services.title1": "Micro-surgery for",
    "services.title2": "your earbuds.",
    "services.subtitle": "From battery swaps to driver replacements, our highly experienced technicians restore the sound you love — repairs typically take about 5 days from the time your item arrives at our store.",
    "services.bookRepair": "Book a repair",
    "services.orContact": "Or contact us",
    "services.svcBatteryTitle": "Battery Replacement",
    "services.svcBatteryDesc": "Restore run-time to like-new. Genuine high quality OEM-grade cells.",
    "services.svcCleanTitle": "Deep Cleaning",
    "services.svcCleanDesc": "Ultrasonic clean of drivers and case contacts.",
    "services.svcDiagTitle": "Diagnostics",
    "services.svcDiagDesc": "Complimentary 12-point health check before repair.",
    "services.svcTurnTitle": "~5 Day Turnaround",
    "services.svcTurnDesc": "Most repairs completed within 5 days of arrival at our store.",
    "services.getInTouch": "Get in touch",
    "services.notSure": "Not sure what's wrong?",
    "services.notSureCopy": "Message us on WhatsApp with a brief description — our team responds within a few hours with next steps.",
    "services.whatsapp": "WhatsApp",
    "services.emailLabel": "Email",
    "services.chat": "Chat",
    "services.chatHours": "Live weekdays · 9am–6pm",
    "services.startRepair": "Book a repair",
    "services.startHead": "Skip the phone tag. Get a repair quote by inspection.",
    "services.startCopy": "Tell us your device type, brand, model, and what's happening. We'll reach out on WhatsApp with a quote after inspection — usually within a few business hours.",
    "services.startPt1": "· Pricing by quote — no payment upfront",
    "services.startPt2": "· Repairs typically completed within 5 days of arrival at our store",
    "services.startPt3": "· 30-day warranty from the day you receive your repaired item",
    "services.orBrowse": "Or browse batteries & parts →",

    // Customer reviews (services & shop-wide)
    "reviews.customerVoicesBadge": "Customer voices",
    "reviews.servicesHeading": "What repair customers say.",
    "reviews.servicesSub": "Real reviews from verified repair customers.",
    "reviews.homeHeading": "Real reviews. Real earbuds saved.",
    "reviews.homeSub": "Every star below comes from a verified Mobile Xpressed customer.",
    "reviews.avgLabel": "Average rating",
    "reviews.basedOn": "based on {n} reviews",
    "reviews.basedOnOne": "based on 1 review",
    "reviews.empty": "No reviews yet — be the first to share your repair experience.",
    "reviews.reviewFor": "Review for",
    "reviews.readMoreOnProduct": "See on product →",

    // Repair booking form
    "intake.badge": "Repair booking",
    "intake.title": "Tell us about your device.",
    "intake.subtitle": "Pricing is provided by quote after inspection — no upfront payment required.",
    "intake.deviceType": "Device type",
    "intake.deviceTypePlaceholder": "Choose device type",
    "intake.pickDeviceType": "Please choose a device type",
    "intake.brand": "Brand",
    "intake.brandPlaceholder": "Select a brand",
    "intake.brandDisabled": "Choose device type first",
    "intake.model": "Model",
    "intake.modelPlaceholder": "Select a model",
    "intake.modelDisabled": "Choose brand first",
    "intake.otherHint": "Selected \"Other\" — please describe the exact brand/model in the issue description below.",
    "intake.repairType": "Repair type",
    "intake.repairTypePlaceholder": "Select a repair type",
    "intake.pickRepairType": "Please choose the issue type",
    "intake.describe": "Describe the issue",
    "intake.describePlaceholder": "When did it start? Any drops or exposure to moisture? What does it sound / feel like?",
    "intake.contact": "Your contact details",
    "intake.fullName": "Full name",
    "intake.phone": "WhatsApp number",
    "intake.phonePlaceholder": "e.g. 0812xxxxxxx",
    "intake.emailAddress": "Email",
    "intake.optional": "optional",
    "intake.emailPlaceholder": "you@example.com",
    "intake.emailHint": "Only as a backup in case we can't reach you on WhatsApp.",
    "intake.submit": "Request repair quote",
    "intake.submitting": "Submitting…",
    "intake.disclaimer": "By submitting you agree to be contacted about your repair via WhatsApp. Diagnostic estimate is provided after inspection — no payment upfront.",
    "intake.success": "Request received",
    "intake.successCopy1": "Reference",
    "intake.successCopy2": "We'll reach out on WhatsApp with a quote after inspection — usually within a few business hours.",
    "intake.another": "Book another repair",
    "intake.pickBrand": "Please choose a brand",
    "intake.pickModel": "Please choose a model",
    "intake.submitted": "Repair request submitted",

    // WhatsApp bubble
    "wa.tooltipLabel": "Chat with us",
    "wa.tooltipMsg": "Hai kak! Ada yang bisa kami bantu?",
    "wa.dismiss": "Dismiss",
    "wa.aria": "Chat with us on WhatsApp",

    // Footer
    "footer.tagline": "Precision TWS batteries, parts, and expert repair — bringing your wireless world back to life.",
    "footer.shop": "Shop",
    "footer.services": "Services",
    "footer.account": "Account",
    "footer.bookRepair": "Book a repair",
    "footer.diagnostics": "Diagnostics",
    "footer.signIn": "Sign in",
    "footer.register": "Register",
    "footer.orders": "Orders",
    "footer.copyright": "All rights reserved.",
    "footer.motto": "Precision · Trust · Expression",

    // Common
    "common.language": "Language",
    "common.english": "English",
    "common.indonesian": "Bahasa Indonesia",
  },

  id: {
    // Navbar
    "nav.repairServices": "Layanan Perbaikan",
    "nav.batteries": "Baterai",
    "nav.parts": "Suku Cadang",
    "nav.accessories": "Aksesori",
    "nav.signIn": "Masuk",
    "nav.getStarted": "Mulai",
    "nav.openCart": "Buka keranjang",
    "nav.searchProducts": "Cari produk",
    "nav.myAccount": "Akun Saya",
    "nav.admin": "Admin",
    "nav.logOut": "Keluar",

    // Banner mode preview / feedback
    "banner.welcome": "Halaman ini sedang dalam pengembangan dan saat ini dalam mode preview, tapi akan berfungsi penuh paling lambat 15 September 2026.",
    "banner.hint": "Untuk komentar, kritik, dan saran, silakan ketik di kotak teks di bawah ini.",
    "banner.placeholder": "Masukan, pertanyaan, atau saran Anda…",
    "banner.send": "Kirim masukan saya",
    "banner.sending": "Mengirim…",
    "banner.thankYouTitle": "Terima kasih",
    "banner.thankYouBody": "Kami akan mendengarkan masukan Anda dengan seksama dan penuh perhatian.",
    "banner.thankYouClose": "Tutup",
    "banner.errorEmpty": "Silakan tulis masukan Anda dulu.",
    "banner.errorGeneric": "Gagal mengirim saat ini. Silakan coba lagi.",
    "banner.errorRate": "Terlalu banyak pesan dari Anda. Mohon tunggu sebentar.",

    // Home
    "home.badge": "Ahli perbaikan TWS terpercaya sejak 2022",
    "home.heroTitle1": "Hidupkan kembali",
    "home.heroTitle2": "earbud Anda.",
    "home.heroSubtitle": "Baterai TWS berkualitas, suku cadang pengganti, dan layanan perbaikan oleh teknisi ahli. Performa pulih dengan cepat.",
    "home.catRepairTitle": "Layanan Perbaikan",
    "home.catBatteriesTitle": "Baterai",
    "home.catPartsTitle": "Suku Cadang",
    "home.catAccessoriesTitle": "Aksesori",
    "home.catPartsShortDesc": "Earbud & casing pengisi daya.",
    "home.catAccessoriesShortDesc": "Eartip, casing pelindung — upgrade kecil, dampak besar.",
    "home.shopBatteries": "Beli baterai",
    "home.repairServices": "Layanan perbaikan",
    "home.warranty": "Garansi 30 hari",
    "home.turnaround": "Selesai ~5 hari",
    "home.certified": "Teknisi bersertifikat",
    "home.thisWeek": "Minggu ini",
    "home.repairs": "120+ perbaikan",
    "home.happyCustomers": "Pelanggan puas",
    "home.catRepairDesc": "Perbaikan bersertifikat dengan penawaran harga setelah pemeriksaan.",
    "home.catBatteriesDesc": "Baterai pengganti kualitas OEM untuk semua brand besar.",
    "home.catPartsDesc": "Driver, casing, engsel, dan toolkit presisi.",
    "home.catAccessoriesDesc": "Kabel, eartip, casing — upgrade kecil, dampak besar.",
    "home.explore": "Jelajahi",
    "home.featured": "Unggulan",
    "home.featuredTitle": "Pulihkan performa hari ini",
    "home.viewAll": "Lihat semua",
    "home.loading": "Memuat produk…",
    "home.guaranteed": "Terjamin",
    "home.trustTitle": "Setiap suku cadang, setiap perbaikan — didukung garansi 30 hari kami.",
    "home.trustCopy": "Kami bertanggung jawab atas setiap baterai dan perbaikan. Jika ada yang tidak beres, akan kami perbaiki.",
    "home.learnMore": "Pelajari layanan perbaikan",

    // FAQ
    "faq.badge": "FAQ",
    "faq.title": "Pertanyaan yang sering diajukan",
    "faq.subtitle": "Semua yang perlu Anda ketahui sebelum memesan perbaikan atau melakukan pemesanan.",
    "faq.q1": "Jenis earbud TWS apa yang Anda perbaiki?",
    "faq.a1": "Kami memperbaiki semua brand besar termasuk Sony, Samsung, Apple, Jabra, Bose, dan masih banyak lagi.",
    "faq.q2": "Berapa lama waktu perbaikan?",
    "faq.a2": "Perbaikan biasanya memakan waktu 5 hari sejak kami menerima perangkat Anda.",
    "faq.q3": "Berapa biaya perbaikan?",
    "faq.a3": "Biaya perbaikan diberikan setelah pemeriksaan. Kami akan menghubungi Anda untuk konfirmasi sebelum melanjutkan.",
    "faq.q4": "Bagaimana jika earbud saya tidak bisa diperbaiki?",
    "faq.a4": "Kami akan memberi tahu Anda dengan laporan kondisi lengkap dan mengembalikan perangkat Anda dengan aman.",
    "faq.q5": "Kurir apa yang Anda gunakan?",
    "faq.a5": "Kami mengirim melalui J&T, Pos Indonesia, dan Paxel.",
    "faq.q6": "Bagaimana saya melacak pesanan saya?",
    "faq.a6": "Anda akan menerima notifikasi WhatsApp berisi nama kurir dan nomor pelacakan setelah perangkat Anda dikirim.",
    "faq.q7": "Apakah Anda memberikan garansi untuk perbaikan?",
    "faq.a7": "Ya, kami memberikan garansi untuk semua layanan perbaikan yang dilakukan oleh Mobile Xpressed.",
    "faq.q8": "Bagaimana saya menghubungi Mobile Xpressed?",
    "faq.a8": "Anda dapat menghubungi kami via WhatsApp menggunakan tombol Hubungi Kami di halaman utama kami.",

    // Testimonials
    "testimonials.badge": "Disukai oleh",
    "testimonials.title": "Mereka yang peduli akan kualitas suara.",
    "testimonials.subtitle": "Dari produser hingga pelari akhir pekan — ribuan orang mempercayai Mobile Xpressed untuk menghidupkan kembali perangkat mereka.",
    "testimonials.t1.quote": "AirPods Pro saya terasa seperti baru setelah pergantian baterainya. Selesai dalam kurang dari 24 jam. Sangat sepadan.",
    "testimonials.t1.role": "Produser, NYC",
    "testimonials.t2.quote": "Saya pesan toolkit dan perbaiki sendiri. Panduannya sempurna dan Galaxy Buds saya hidup kembali.",
    "testimonials.t2.role": "Software Engineer",
    "testimonials.t3.quote": "Harga baterai TWS bagus dan pengiriman cepat. Saya sudah bilang ke semua orang di studio soal Mobile Xpressed.",
    "testimonials.t3.role": "Sound Designer",

    // Order status
    "status.pending": "Menunggu",
    "status.paid": "Dibayar",
    "status.shipped": "Dikirim",
    "status.delivered": "Terkirim",
    "status.cancelled": "Dibatalkan",
    "status.refunded": "Dikembalikan",

    // Shop
    "shop.badge": "Toko",
    "shop.title": "Semua yang Anda butuhkan",
    "shop.subtitle": "Baterai, suku cadang dan aksesori pilihan untuk mengembalikan performa terbaik earbud TWS Anda.",
    "shop.searchPlaceholder": "Cari baterai, suku cadang, brand…",
    "shop.clearSearch": "Hapus pencarian",
    "shop.filterAll": "Semua",
    "shop.filterRepair": "Layanan Perbaikan",
    "shop.filterBatteries": "Baterai",
    "shop.filterParts": "Suku Cadang",
    "shop.filterAccessories": "Aksesori",
    "shop.loading": "Memuat produk…",
    "shop.noResults": "Tidak ada produk ditemukan",
    "shop.noMatch": "Tidak ada hasil untuk",
    "shop.tryDifferent": "Coba kategori lain.",
    "shop.resultsFor": "hasil untuk",

    // Product card
    "product.add": "Tambah",

    // Product detail
    "product.back": "Kembali",
    "product.addToCart": "Masukkan ke keranjang",
    "product.reviews": "ulasan",
    "product.freeShipping": "Gratis ongkir",
    "product.thirtyDayReturns": "Retur 30 hari",
    "product.warranty": "Garansi 30 hari",
    "product.brand": "Brand",
    "product.stock": "Stok",
    "product.notFound": "Produk tidak ditemukan",
    "product.backToShop": "Kembali ke toko",
    "product.loading": "Memuat…",

    // Product reviews
    "reviews.customerReviews": "Ulasan pelanggan",
    "reviews.noReviews": "Belum ada ulasan. Jadilah yang pertama berbagi pengalaman.",
    "reviews.signInPrompt": "Masuk untuk memberikan ulasan.",
    "reviews.signIn": "Masuk",
    "reviews.writeReview": "Tulis ulasan",
    "reviews.yourRating": "Rating Anda",
    "reviews.title": "Judul",
    "reviews.titlePlaceholder": "Ringkas pengalaman Anda",
    "reviews.yourReview": "Ulasan Anda",
    "reviews.reviewPlaceholder": "Apa yang bagus, apa yang kurang, tips untuk pembeli lain…",
    "reviews.postReview": "Kirim ulasan",
    "reviews.posting": "Mengirim…",
    "reviews.pickRating": "Silakan pilih rating",
    "reviews.alreadyReviewed": "Terima kasih — Anda sudah memberikan ulasan untuk produk ini.",
    "reviews.verified": "Terverifikasi",
    "reviews.deleteConfirm": "Hapus ulasan Anda?",
    "reviews.deleted": "Ulasan dihapus",
    "reviews.posted": "Ulasan dikirim",
    "reviews.loading": "Memuat ulasan…",

    // Cart
    "cart.title": "Keranjang Anda",
    "cart.empty": "Keranjang Anda kosong",
    "cart.emptyHint": "Tambahkan baterai atau suku cadang untuk mulai.",
    "cart.browseShop": "Lihat toko",
    "cart.subtotal": "Subtotal",
    "cart.shippingNotice": "Ongkir & pajak dihitung saat checkout.",
    "cart.checkout": "Checkout",

    // Checkout
    "checkout.title": "Checkout",
    "checkout.shippingDetails": "Detail pengiriman",
    "checkout.fullName": "Nama lengkap",
    "checkout.province": "Provinsi",
    "checkout.provincePlaceholder": "Pilih provinsi",
    "checkout.regency": "Kota / Kabupaten",
    "checkout.regencyPlaceholder": "Pilih kota/kabupaten",
    "checkout.district": "Kecamatan",
    "checkout.districtPlaceholder": "Pilih kecamatan",
    "checkout.village": "Kelurahan/Desa",
    "checkout.villagePlaceholder": "Pilih kelurahan/desa",
    "checkout.postalCode": "Kode pos",
    "checkout.postalCodePlaceholder": "Terisi otomatis",
    "checkout.addressLoadError": "Gagal memuat pilihan. Periksa koneksi Anda dan coba lagi.",
    "checkout.retry": "Coba lagi",
    "checkout.addressDetail": "Detail alamat",
    "checkout.addressDetailPlaceholder": "Nama jalan, nomor rumah, RT/RW, gedung, lantai…",
    "checkout.phone": "Nomor telepon",
    "checkout.stripeNotice": "Anda akan diarahkan ke checkout aman Stripe untuk menyelesaikan pembayaran. Kartu uji: 4242 4242 4242 4242, tanggal apa saja di masa depan, CVC apa saja.",
    "checkout.paySecurely": "Bayar dengan aman",
    "checkout.redirecting": "Mengalihkan ke Stripe…",
    "checkout.orderSummary": "Ringkasan pesanan",
    "checkout.qty": "Jml",
    "checkout.shipping": "Pengiriman",
    "checkout.free": "Gratis",
    "checkout.total": "Total",
    "checkout.pleaseSignIn": "Silakan masuk untuk checkout.",
    "checkout.cartEmpty": "Keranjang Anda kosong.",
    "checkout.continueShopping": "Lanjut belanja",
    "checkout.addressIncomplete": "Silakan lengkapi provinsi, kota, kecamatan dan kelurahan agar kode pos terisi otomatis.",
    "checkout.savedAddresses": "Alamat tersimpan",
    "checkout.useNewAddress": "Gunakan alamat baru",
    "checkout.saveThisAddress": "Simpan alamat ini untuk pesanan berikutnya",
    "checkout.addressLabel": "Label (mis. Rumah, Kantor)",

    // Payment
    "payment.confirming": "Mengonfirmasi pembayaran…",
    "payment.confirmingSub": "Mohon tunggu sementara kami verifikasi transaksi Anda dengan Stripe.",
    "payment.success": "Pembayaran berhasil",
    "payment.successMsg": "Terima kasih telah berbelanja di Mobile Xpressed. Kami akan mengirim email saat pesanan Anda dikirim.",
    "payment.viewOrders": "Lihat pesanan saya",
    "payment.keepShopping": "Lanjut belanja",
    "payment.stillProcessing": "Masih memproses…",
    "payment.stillProcessingSub": "Pembayaran memakan waktu lebih lama dari biasanya. Cek akun Anda untuk status final.",
    "payment.goToAccount": "Ke akun",
    "payment.failed": "Pembayaran gagal",
    "payment.failedSub": "Kami tidak dapat mengonfirmasi pembayaran Anda. Silakan coba lagi.",
    "payment.backToCheckout": "Kembali ke checkout",
    "payment.cancelled": "Pembayaran dibatalkan",
    "payment.cancelledSub": "Tenang saja — keranjang Anda tersimpan. Anda bisa checkout kapan saja siap.",
    "payment.returnToCheckout": "Kembali ke checkout",

    // Auth
    "auth.welcomeBack": "Selamat datang kembali",
    "auth.welcomeSub": "Masuk untuk melanjutkan perjalanan Anda di Mobile Xpressed.",
    "auth.email": "Email",
    "auth.password": "Kata sandi",
    "auth.signIn": "Masuk",
    "auth.signingIn": "Sedang masuk…",
    "auth.continueGoogle": "Lanjutkan dengan Google",
    "auth.orEmail": "atau email",
    "auth.newHere": "Baru di Mobile Xpressed?",
    "auth.createAccount": "Buat akun",
    "auth.createTitle": "Buat akun",
    "auth.createSub": "Bergabunglah dengan Mobile Xpressed untuk melacak pesanan dan menyimpan favorit.",
    "auth.name": "Nama",
    "auth.createBtn": "Buat akun",
    "auth.creating": "Membuat…",
    "auth.haveAccount": "Sudah punya akun?",
    "auth.welcomeToast": "Selamat datang kembali!",
    "auth.createdToast": "Akun berhasil dibuat — selamat datang!",

    // Account
    "account.yourOrders": "Pesanan Anda",
    "account.orders": "Pesanan",
    "account.adminPanel": "Panel Admin",
    "account.logOut": "Keluar",
    "account.noOrders": "Belum ada pesanan",
    "account.noOrdersHint": "Pesanan Anda akan muncul di sini.",
    "account.startShopping": "Mulai belanja",
    "account.order": "Pesanan",
    "account.qty": "Jml",
    "account.loading": "Memuat…",
    "account.addresses": "Alamat",
    "account.savedAddresses": "Alamat tersimpan",
    "account.noAddresses": "Belum ada alamat tersimpan",
    "account.noAddressesHint": "Simpan alamat saat checkout atau tambahkan di sini agar pesanan berikutnya lebih cepat.",
    "account.addAddress": "Tambah alamat",
    "account.editAddress": "Ubah alamat",
    "account.deleteAddress": "Hapus",
    "account.setDefault": "Jadikan utama",
    "account.default": "Utama",
    "account.addressLabel": "Label",
    "account.addressLabelPlaceholder": "Rumah, Kantor…",
    "account.recipientName": "Nama penerima",
    "account.saveAddress": "Simpan alamat",
    "account.saving": "Menyimpan…",
    "account.addressSaved": "Alamat tersimpan.",
    "account.addressDeleted": "Alamat dihapus.",
    "account.defaultUpdated": "Alamat utama diperbarui.",
    "account.cancel": "Batal",
    "account.deleteConfirm": "Alamat ini akan dihapus permanen.",

    // Repair services
    "services.badge": "Layanan Perbaikan",
    "services.title1": "Bedah mikro untuk",
    "services.title2": "earbud Anda.",
    "services.subtitle": "Dari pergantian baterai hingga pergantian driver, teknisi bersertifikat kami mengembalikan kualitas suara yang Anda cintai — perbaikan biasanya memakan waktu sekitar 5 hari sejak barang tiba di toko kami.",
    "services.bookRepair": "Pesan perbaikan",
    "services.orContact": "Atau hubungi kami",
    "services.svcBatteryTitle": "Pergantian Baterai",
    "services.svcBatteryDesc": "Kembalikan daya tahan seperti baru. Sel baterai kualitas OEM asli.",
    "services.svcCleanTitle": "Pembersihan Mendalam",
    "services.svcCleanDesc": "Pembersihan ultrasonik driver dan kontak casing.",
    "services.svcDiagTitle": "Diagnostik",
    "services.svcDiagDesc": "Pemeriksaan kesehatan 12 titik gratis sebelum perbaikan.",
    "services.svcTurnTitle": "Selesai ~5 Hari",
    "services.svcTurnDesc": "Sebagian besar perbaikan selesai dalam 5 hari setelah barang tiba di toko kami.",
    "services.getInTouch": "Hubungi kami",
    "services.notSure": "Tidak yakin masalahnya?",
    "services.notSureCopy": "Pesan kami di WhatsApp dengan deskripsi singkat — tim kami akan merespons dalam beberapa jam dengan langkah berikutnya.",
    "services.whatsapp": "WhatsApp",
    "services.emailLabel": "Email",
    "services.chat": "Chat",
    "services.chatHours": "Aktif hari kerja · 9 pagi – 6 sore",
    "services.startRepair": "Pesan perbaikan",
    "services.startHead": "Tanpa telepon panjang. Dapatkan penawaran perbaikan setelah pemeriksaan.",
    "services.startCopy": "Beri tahu kami jenis perangkat, brand, model, dan apa yang terjadi. Kami akan menghubungi Anda via WhatsApp dengan penawaran setelah pemeriksaan — biasanya dalam beberapa jam kerja.",
    "services.startPt1": "· Harga berdasarkan penawaran — tanpa pembayaran di depan",
    "services.startPt2": "· Perbaikan biasanya selesai dalam 5 hari setelah barang tiba di toko kami",
    "services.startPt3": "· Garansi 30 hari sejak barang selesai perbaikan Anda terima",
    "services.orBrowse": "Atau lihat baterai & suku cadang →",

    // Ulasan pelanggan (untuk halaman jasa & seluruh toko)
    "reviews.customerVoicesBadge": "Suara pelanggan",
    "reviews.servicesHeading": "Kata pelanggan perbaikan kami.",
    "reviews.servicesSub": "Ulasan asli dari pelanggan perbaikan yang terverifikasi.",
    "reviews.homeHeading": "Ulasan asli. Earbud yang terselamatkan.",
    "reviews.homeSub": "Setiap bintang di bawah datang dari pelanggan Mobile Xpressed yang terverifikasi.",
    "reviews.avgLabel": "Rata-rata rating",
    "reviews.basedOn": "berdasarkan {n} ulasan",
    "reviews.basedOnOne": "berdasarkan 1 ulasan",
    "reviews.empty": "Belum ada ulasan — jadilah yang pertama membagikan pengalaman perbaikan Anda.",
    "reviews.reviewFor": "Ulasan untuk",
    "reviews.readMoreOnProduct": "Lihat di produk →",

    // Repair booking form
    "intake.badge": "Pemesanan perbaikan",
    "intake.title": "Ceritakan tentang perangkat Anda.",
    "intake.subtitle": "Harga diberikan melalui penawaran setelah pemeriksaan — tanpa pembayaran di depan.",
    "intake.deviceType": "Jenis perangkat",
    "intake.deviceTypePlaceholder": "Pilih jenis perangkat",
    "intake.pickDeviceType": "Silakan pilih jenis perangkat",
    "intake.brand": "Brand",
    "intake.brandPlaceholder": "Pilih brand",
    "intake.brandDisabled": "Pilih jenis perangkat terlebih dahulu",
    "intake.model": "Model",
    "intake.modelPlaceholder": "Pilih model",
    "intake.modelDisabled": "Pilih brand terlebih dahulu",
    "intake.otherHint": "Anda memilih \"Other\" — silakan jelaskan brand/model yang sebenarnya di kolom deskripsi masalah di bawah.",
    "intake.repairType": "Jenis perbaikan",
    "intake.repairTypePlaceholder": "Pilih jenis perbaikan",
    "intake.pickRepairType": "Silakan pilih jenis masalahnya",
    "intake.describe": "Jelaskan masalahnya",
    "intake.describePlaceholder": "Kapan mulai terjadi? Ada terjatuh atau terkena air? Bagaimana suaranya / rasanya?",
    "intake.contact": "Detail kontak Anda",
    "intake.fullName": "Nama lengkap",
    "intake.phone": "Nomor WhatsApp",
    "intake.phonePlaceholder": "cth. 0812xxxxxxx",
    "intake.emailAddress": "Email",
    "intake.optional": "opsional",
    "intake.emailPlaceholder": "anda@contoh.com",
    "intake.emailHint": "Hanya sebagai cadangan jika kami tidak dapat menghubungi Anda via WhatsApp.",
    "intake.submit": "Minta penawaran perbaikan",
    "intake.submitting": "Mengirim…",
    "intake.disclaimer": "Dengan mengirim, Anda setuju untuk dihubungi terkait perbaikan Anda via WhatsApp. Perkiraan diagnostik diberikan setelah pemeriksaan — tanpa pembayaran di depan.",
    "intake.success": "Permintaan diterima",
    "intake.successCopy1": "Referensi",
    "intake.successCopy2": "Kami akan menghubungi Anda via WhatsApp dengan penawaran setelah pemeriksaan — biasanya dalam beberapa jam kerja.",
    "intake.another": "Pesan perbaikan lain",
    "intake.pickBrand": "Silakan pilih brand",
    "intake.pickModel": "Silakan pilih model",
    "intake.submitted": "Permintaan perbaikan terkirim",

    // WhatsApp bubble
    "wa.tooltipLabel": "Chat dengan kami",
    "wa.tooltipMsg": "Hai kak! Ada yang bisa kami bantu?",
    "wa.dismiss": "Tutup",
    "wa.aria": "Chat dengan kami di WhatsApp",

    // Footer
    "footer.tagline": "Baterai TWS presisi, suku cadang, dan perbaikan profesional — menghidupkan kembali dunia wireless Anda.",
    "footer.shop": "Toko",
    "footer.services": "Layanan",
    "footer.account": "Akun",
    "footer.bookRepair": "Pesan perbaikan",
    "footer.diagnostics": "Diagnostik",
    "footer.signIn": "Masuk",
    "footer.register": "Daftar",
    "footer.orders": "Pesanan",
    "footer.copyright": "Seluruh hak cipta dilindungi.",
    "footer.motto": "Presisi · Kepercayaan · Ekspresi",

    // Common
    "common.language": "Bahasa",
    "common.english": "English",
    "common.indonesian": "Bahasa Indonesia",
  },
};
